import { getAuth, signOut } from "firebase/auth"
import { app } from "../../firebase"
import { Loading } from "notiflix";

import { contexto } from "../CustomProvider";
import { useContext } from "react";
import { updateTableKeysLocalStorage } from "../utils";

const auth = getAuth(app);

const LogOut = ({ show }) => {
    const { usuarioContexto, setUsuarioContexto } = useContext(contexto);

    const handleLogout = () => {
        Loading.hourglass();
        updateTableKeysLocalStorage("user", {});

        signOut(auth)
            .finally(() => {
                setUsuarioContexto({});
                setTimeout(() => {
                    Loading.remove();
                }, 1000);
            })
    }

    if (show) {
        return (
            <>
                {usuarioContexto && <button onClick={handleLogout} className="logOut">Cerrar Sesión</button>}
            </>
        );
    }

    return null;
}

export default LogOut;